import { createNullableProvideInject } from '@collector/shared-ui'

import { CustomIncidentNames } from '../configuration'

export const [provideCustomIncidentNames, injectCustomIncidentNames] =
  createNullableProvideInject<CustomIncidentNames>('customIncidentNames')
